module.exports = __webpack_public_path__ + "img/home_banner_wrap5.e1698596.png";